import {connect} from 'react-redux';
import AddEditDialog from '../../../components/elements/translation/AddEditDialog';
import {cancelAddEditTranslations, submitAddEditTranslation} from "../../../actions/translationAction";

const mapStateToProps = state => {
    return {
        addEditDialog: state.translation.addEditDialog
    }
};

const mapDispatchToProps = dispatch => {
    return {
        cancelAddEditTranslations: () => {
            dispatch(cancelAddEditTranslations());
        },
        submitAddEditTranslation: (translationId, key, de, en, translationType) => {
            dispatch(submitAddEditTranslation(translationId, key, de, en, translationType));
        }
    }
};

const AddEditDialogContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(AddEditDialog);

export default AddEditDialogContainer;